module.exports = __webpack_public_path__ + "static/media/the-dutch-1.0880e566.jpg";